import { FC } from 'react'
import { Form, Select, Button, Input, Row, Col,Upload } from 'antd'
import { uploadLink } from '../../../../API/priceComparison'
import {
  PARAM_SESSION_USER,
  PARAM_SESSION_KEY,
} from '../../../../utils/session'
import { useAuth } from 'bxl-auth'

const SelectOptions = [
  {
    label: 'OFF',
    value: 'OFF',
  },
  {
    label: 'ON',
    value: 'ON',
  },
]

enum BtnType {
  "query",
  "download",
}

const buttonList: { label: string; type: BtnType }[] = [
  {
    label: '查询',
    type: BtnType.query,
  },
  {
    label: '下载',
    type: BtnType.download,
  },
]

export interface FormData {
  productId: string
  state: string
}

export interface ImportDate {
  productId: string
  state: string
  targetedPrice: string
}

interface HeaderProps {
  onQuery:(data: FormData) => void
  onAdd:() => void
  onDownload:(data: FormData) => void
  onImport:(data :ImportDate[]) => void
}

const Header: FC<HeaderProps> = ({ onQuery, onAdd, onDownload, onImport }) => {
  const [formInstance] = Form.useForm<FormData>()
  const { user } = useAuth()
  const handClick = (type: BtnType) => {
    formInstance.validateFields().then(formData => {
      switch (type) {
        case BtnType.download:
          onDownload(formData)
          break
        case BtnType.query:
          onQuery(formData)
          break
      }
    })
    
  }
  const onChange = (data) => {
    if(data?.file?.response) {
      console.log(data?.file?.response)
      onImport(data?.file?.response || {})
    }
  }
  return (
    <Form form={formInstance}>
      <Row>
        <Col span={5}>
          <Form.Item label="Product ID" name="productId">
            <Input placeholder="please input Product ID " allowClear />
          </Form.Item>
        </Col>
        <Col span={5} offset={1}>
          <Form.Item label="State" name="state">
            <Select placeholder="please select State " allowClear>
              {SelectOptions.map(option => (
                <Select.Option value={option.value} key={option.value}>
                  {option.label}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        {buttonList.map(item => (
          <Col key={item.type} offset={1}>
            <Button type="primary" onClick={() => handClick(item.type)}>
              {item.label}
            </Button>
          </Col>
        ))}
        <Col offset={1}>
          <Button type="primary" onClick={onAdd}>
            新增
          </Button>
        </Col>
        <Col offset={1}>
          <Upload
            accept=".csv"
            action={uploadLink}
            headers={{
              [PARAM_SESSION_USER]: user?.userId || '',
              [PARAM_SESSION_KEY]: user?.sessionKey || '',
            }}
            showUploadList={false}
            name="file"
            onChange={onChange}
          >
            <Button type="primary">导入</Button>
          </Upload>
        </Col>
      </Row>
    </Form>
  )
}

export default Header